import { MenuT } from 'types/frontend/Menu';
import { MyDate } from 'utils/shared/MyDate';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const counselMenuRootPath = '/teacherSide/counsel';

const counselMenu: MenuT = [
  {
    title: t('상담'),
    items: [
      {
        title: t('상담 기록'),
        path: `${counselMenuRootPath}/log`,
      },
      {
        title: t('월별 상담 현황'),
        path: `${counselMenuRootPath}/logCount`,
        accessablePositions: ['director', 'assistantDirector'],
        newUntil: MyDate.fromNumber(20250315),
      },
    ],
  },
  {
    title: t('상담톡'),
    items: [
      {
        title: t('상담톡'),
        path: `https://inapp.anotherclass.co.kr/chatApp/`,
      },
    ],
  },
];

export { counselMenu };
